
import TradeRepository from "@/repositories/TradeRepository";
import { computed, defineComponent } from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import VChart from "vue-echarts";
import { GridComponent, TooltipComponent, TitleComponent, AxisPointerComponent } from "echarts/components";

use([CanvasRenderer, BarChart, GridComponent, TooltipComponent, TitleComponent, AxisPointerComponent]);

export default defineComponent({
  components: { VChart },

  setup() {
    const options = computed(() => TradeRepository.options());

    return {
      options,
    };
  },
});
